import { render } from "./Enterprise_en_m.vue?vue&type=template&id=25abe618"
import script from "./Enterprise_en_m.vue?vue&type=script&lang=js"
export * from "./Enterprise_en_m.vue?vue&type=script&lang=js"
script.render = render

export default script